//Axios: Peticiones HTTP via Ajax
import axios from 'axios';

let token = '';
let dataStorage = localStorage.getItem(process.env.TOKEN_NAME);

if ( dataStorage === null || dataStorage == "" ) {
  token = '';
} else {
  dataStorage = JSON.parse(dataStorage);
  token = dataStorage.token;
}

export const HTTP_INFO_VOTACION = axios.create({
  baseURL: '/infovotacion/',
});

export const HTTP_GURU_BACKEND = axios.create({
  baseURL: '/backend/',
});

export const HTTP_CONFIG = axios.create({
  baseURL: '/config/',
});

//Sweet Alert 2
export const swal = require('sweetalert2');

//moment
export const moment = require('moment');

//Paths
export const URL_DOCS = process.env.PATH_API + "/v2/";